export const filterWrapperStyles = {
    alignItems: 'center',
    display: 'flex',
    gap: 2,
    justifyContent: 'space-between',
};
